<template>
	<div>
		<!-- Headline -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("product") }}
		</div>

		<!-- Items -->
		<j-card class="bg5">
			<j-list :list="computedProduct">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
						{{ item.label }}
					</div>
					<div class="flex xs-6 xs-left xs-middle lh125">
						<router-link :to="item.link" v-if="item.link">
							{{ item.value }}
						</router-link>
						<template v-else>
							{{ item.value }}
						</template>
					</div>
				</div>
			</j-list>
			<div class="bg5 ta2 fs3 p2" v-if="computedProduct.length === 0">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import dayjs from "dayjs"
import get from "lodash.get"

export default {
	components: { JCard, JList },

	props: {
		/**
		 * This is a type product we get from GraphQl on policies.product
		 */
		product: {
			type: Object,
			required: true,
			default: () => ({
				name: null,
				productId: {
					plan: null,
					type: null,
					version: null
				}
			})
		}
	},

	computed: {
		computedProduct() {
			const data = this.product
			return [
				{
					label: this.$t("name"),
					value: data.name,
					link: {
						name: "ProductDetail",
						params: {
							plan: get(data, "productId.plan"),
							version: get(data, "productId.version"),
							type: get(data, "productId.type")
						}
					}
				},
				{ label: this.$t("plan"), value: get(data, "productId.plan") },
				{ label: this.$t("version"), value: get(data, "productId.version") },
				{ label: this.$t("type"), value: get(data, "productId.type") }
			]
		}
	}
}
</script>
